exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-btn[data-v-179c8990] {\n  height: 55px !important;\n}\n.v-btn__content[data-v-179c8990] {\n  font-size: small;\n  display: flex;\n  flex-direction:column;\n  text-align: center;\n  justify-content: center;\n}\n.item[data-v-179c8990] {\n  padding-right: 4px;\n  margin-left: auto;\n  text-align: center;\n}\n", ""]);

// exports
